import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './auth/auth.context';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ConversasPage } from './pages/ConversasPage';
import { ConversaDetailPage } from './pages/ConversaDetailPage';
import { ClientesPage } from './pages/ClientesPage';
import { DuplicatasPage } from './pages/DuplicatasPage';
import { AuditoriaPage } from './pages/AuditoriaPage';
import { TicketsPage } from './pages/TicketsPage';
import { InsightsPage } from './pages/InsightsPage';
import { WebhooksPage } from './pages/WebhooksPage';
import { MapasPage } from './pages/MapasPage';
import { ConfigPage } from './pages/ConfigPage';
import { TestModePage } from './pages/TestModePage';
import { PlaygroundPage } from './pages/PlaygroundPage';
import { SystemLogsPage } from './pages/SystemLogsPage';
import { EmailsPage } from './pages/EmailsPage';
import { ComprasPage } from './pages/ComprasPage';
import { WhatsappCanaisPage } from './pages/WhatsappCanaisPage';
import { DisparosPage } from './pages/DisparosPage';
import { NutricaoPage } from './pages/NutricaoPage';
import { AtivacaoPage } from './pages/AtivacaoPage';
import { ChatsPage } from './pages/ChatsPage';
import { AppLayout } from './components/AppLayout';

export function App(): JSX.Element {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <p className="text-sara-text-muted">carregando…</p>
      </div>
    );
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        {/* Página standalone de QR — auth via token JWT no querystring,
            funciona sem login no painel admin */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      {/* QR standalone também acessível quando logado (mesma rota) */}
      <Route
        path="*"
        element={
          <AppLayout>
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/insights" element={<InsightsPage />} />
              <Route path="/conversas" element={<ConversasPage />} />
              <Route path="/conversas/:id" element={<ConversaDetailPage />} />
              <Route path="/clientes" element={<ClientesPage />} />
              <Route path="/duplicatas" element={<DuplicatasPage />} />
              <Route path="/auditoria" element={<AuditoriaPage />} />
              <Route path="/tickets" element={<TicketsPage />} />
              <Route path="/webhooks" element={<WebhooksPage />} />
              <Route path="/mapas" element={<MapasPage />} />
              <Route path="/compras" element={<ComprasPage />} />
              <Route path="/emails" element={<EmailsPage />} />
              <Route path="/whatsapp/canais" element={<WhatsappCanaisPage />} />
              <Route path="/whatsapp/disparos" element={<DisparosPage />} />
              <Route path="/nutricao" element={<NutricaoPage />} />
              <Route path="/ativacao" element={<AtivacaoPage />} />
              <Route path="/chats" element={<ChatsPage />} />
              <Route path="/config" element={<ConfigPage />} />
              <Route path="/test-mode" element={<TestModePage />} />
              <Route path="/playground" element={<PlaygroundPage />} />
              <Route path="/system-logs" element={<SystemLogsPage />} />
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </AppLayout>
        }
      />
    </Routes>
  );
}
